<template>
    <div
        id="be-listino"
        class="bg-light"
    >
        <div class="body-wrapper">
            <main class="pt-0 mt-0">
                <div class="barra-titolo-azioni fissa-in-alto bg-white border-bottom py-2 mt-0">
                    <div class="container-fluid">
                        <div class="row d-flex justify-content-between flex-wrap align-items-center">
                            <div class="col-sm-6 d-flex justify-content-start align-items-center">
                                <div class="navbar-nav pulsante-indietro">
                                    <a
                                        title="Indietro"
                                        @click="goToPricelists"
                                    >
                                        <font-awesome-icon :icon="['fas', 'arrow-left']" />
                                    </a>
                                </div>
                                <h1
                                    class="ml-3 mb-0 text-dark"
                                    v-show="!editingPricelistName"
                                >
                                    <span class="titolo-listino">
                                        {{ pricelist.nome }}
                                    </span>
                                    <a
                                        href=""
                                        @click.prevent="editingPricelistName = true"
                                    >
                                        &nbsp;
                                        <font-awesome-icon :icon="['fas', 'pencil-alt']" />
                                    </a>
                                </h1>
                                <b-input-group
                                    class="modifica-nome-listino mb-0 col-sm-5"
                                    v-show="editingPricelistName"
                                >
                                    <b-form-input
                                        :value="pricelist.nome"
                                        ref="pricelistNameInput"
                                    ></b-form-input>
                                    <b-input-group-append v-show="!savingPricelistName">
                                        <b-button
                                            class="btn btn-primary rounded-right"
                                            @click="setPricelistName()"
                                        >
                                            {{$t("Salva")}}
                                        </b-button>
                                    </b-input-group-append>
                                    <b-input-group-append v-show="savingPricelistName">
                                        <b-button
                                            class="btn btn-primary rounded-right"
                                            disabled
                                        >
                                            {{$t("Salvataggio")}}
                                        </b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </div>
                            <div class="col-sm-6 mt-3 mt-sm-0">
                                <ul class="d-sm-flex justify-content-end flex-wrap mb-0">
                                    <li class="d-inline-block">
                                        <button
                                            type="button"
                                            class="pulsante-assegna-listino btn btn-primary btn-rikorda1"
                                            @click="showPricelistAssignToEventsModal"
                                        >
                                            {{ $t("Assegna a galleria") }}
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="listino d-flex justify-content-between flex-wrap position-relative">
                    <div class="container-fluid">
                        <!--ul class="categorie-listino mt-3 nav nav-tabs d-flex flex-row justify-content-center"-->
                        <draggable
                            v-model="categories"
                            handle=".sort-icon"
                            @change="sortCategories"
                            tag="ul"
                            class="categorie-listino mt-3 nav nav-tabs d-flex flex-row justify-content-center"
                            :move="checkCategorySort"
                        >
                            <li
                                class="nav-item"
                                v-for="category in categories"
                                :key="category.idGruppo"
                                @click="changeActiveCategory(category)"
                            >
                                <a
                                    class="nav-link text-uppercase font-weight-bold"
                                    :class="{
                                        active:
                                            category.idGruppo ===
                                            activeCategory.idGruppo
                                    }"
                                >
                                    <font-awesome-icon
                                        :icon="['fas', 'arrows-alt']"
                                        class="sort-icon mr-1"
                                        v-if="category.idGruppo !== 'spese'"
                                    />
                                    <span class="categoria">
                                        {{ category.idGruppo === "spese" ? $t("Spese di spedizione") : category.nome }}
                                    </span>
                                    &nbsp;
                                    <span class="conteggio-elementi small">
                                        [{{ category.articles.length }}]
                                    </span>
                                </a>
                            </li>

                            <li class="nav-item">
                                <a
                                    class="nav-link text-uppercase font-weight-bold"
                                    v-b-modal.new-category-modal
                                >
                                    {{ $t("Aggiungi categoria") }}
                                </a>
                            </li>
                        </draggable>
                        <!--/ul-->

                        <div
                            class="prezzi tab-content mt-3"
                            v-show="activeCategory.idGruppo"
                        >
                            <div
                                class="tab-pane fade show active"
                                id="categoria1"
                                role="tabpanel"
                                aria-labelledby="categoria1-tab"
                            >
                                <div class="intestazione-categoria-listino d-flex justify-content-between flex-wrap align-items-center">
                                    <h2 class="text-blurikorda mb-0 mt-3">
                                        <font-awesome-icon :icon="['fas', 'tag']" />&nbsp;
                                        {{ activeCategory.idGruppo === "spese" ? $t("Spese di spedizione") : activeCategory.nome }}
                                        <a
                                            v-if="activeCategory.idGruppo !== 'spese' && activeCategory.tipoGruppo !== 'CUSTOMIZABLE'"
                                            class="btn-lg"
                                            v-b-modal.delete-category-modal
                                        >
                                            <font-awesome-icon :icon="['fas', 'trash']" />
                                        </a>
                                    </h2>
                                    <!--<span class="text-warning mt-3" v-show="savingState === 'saving'">{{$t("Salvataggio...")}}</span>-->
                                    <!--<span class="text-success mt-3" v-show="savingState === 'saved'">{{$t("Modifiche salvate")}}</span>-->
                                </div>

                                <div class="controlli row mt-3 d-flex justify-content-between align-items-center flex-wrap">
                                    <div class="d-flex justify-content-start align-items-center col-lg-5"></div>
                                    <div class="d-flex justify-content-start justify-content-lg-end align-items-center col-lg-7 mt-3 mt-lg-0">
                                        <button
                                            type="button"
                                            class="btn btn-light border"
                                            @click="showPricelistArticlesModal"
                                            v-show="activeCategory.idGruppo !== 'spese'"
                                        >
                                            {{ $t("Aggiungi elemento") }}
                                        </button>
                                    </div>
                                </div>

                                <table class="tabella-responsive table table-striped mt-3 mb-0">
                                    <thead>
                                        <tr>
                                            <th
                                                scope="col"
                                                class="px-1"
                                            ></th>
                                            <th
                                                scope="col"
                                                class="pl-2"
                                            >
                                                {{ $t("Anteprima") }}
                                            </th>
                                            <th
                                                scope="col"
                                                class="px-1"
                                            >
                                                {{ $t("Nome") }}
                                            </th>
                                            <!--<th scope="col" class="px-1">
                                                {{ $t("Costo di laboratorio") }}
                                            </th>-->
                                            <th
                                                scope="col"
                                                class="px-1"
                                            >
                                                {{ $t("Prezzo") }}
                                            </th>
                                            <!--<th scope="col" class="px-1">
                                                {{ $t("Guadagno") }}
                                            </th>-->
                                            <th
                                                scope="col"
                                                class="px-1"
                                            >
                                                {{ activeCategory.removableArticles ? $t("Rimuovi") : "" }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <draggable
                                        v-model="activeCategory.articles"
                                        handle=".sort-icon"
                                        @change="sortArticles"
                                        tag="tbody"
                                    >
                                        <tr
                                            class="prezzo"
                                            v-for="(article, articleIndex) in activeCategory.articles"
                                            :key="article.codArticolo"
                                        >
                                            <td class="trascina align-middle px-1 text-center">
                                                <font-awesome-icon
                                                    :icon="['fas', 'arrows-alt']"
                                                    class="sort-icon"
                                                    v-show="activeCategory.sortableArticles"
                                                />
                                            </td>
                                            <td style="width: 5rem;">
                                                <img
                                                    v-if="isProjectProduct(article)"
                                                    @click.prevent="onEditPreview(article)"
                                                    style="max-width: 5rem;"
                                                    :src="articlePreviewDataSrc(article)"
                                                />
                                            </td>
                                            <td
                                                class="nome align-middle px-1"
                                                data-title="Nome"
                                            >
                                                <a v-if="article.nome === 'transfertF'">
                                                    {{ $t("Pagamento e ritiro presso il punto vendita") }}
                                                </a>
                                                <a v-else-if="article.nome === 'transfertFOnline'">
                                                    {{ $t("Pagamento online e ritiro presso il punto vendita") }}
                                                </a>
                                                <a v-else-if="article.nome === 'transfertD'">
                                                    {{ $t("A domicilio") }}
                                                </a>
                                                <div v-else>
                                                    <div>
                                                        <span v-show="!articlesStatuses[articleIndex].editing">
                                                            {{ article.nome }}
                                                            <a @click.prevent="articlesStatuses[articleIndex].editing = true">
                                                                &nbsp;
                                                                <font-awesome-icon :icon="['fas', 'pencil-alt']" />
                                                            </a>
                                                            <!--br /-->
                                                            <!--small class="font-italic">{{ article.descrizione }} ({{ article.codArticolo }})</small-->
                                                        </span>
                                                        <b-input-group
                                                            class="mb-0 col-sm-12"
                                                            v-show="articlesStatuses[articleIndex].editing"
                                                        >
                                                            <b-form-input v-model="article.nome"></b-form-input>
                                                            <b-input-group-append v-show="!articlesStatuses[articleIndex].saving">
                                                                <b-button
                                                                    class="btn btn-primary rounded-right"
                                                                    @click="onArticleNameChange($event, articleIndex)"
                                                                >
                                                                    {{$t("Salva")}}
                                                                </b-button>
                                                            </b-input-group-append>
                                                            <b-input-group-append v-show="articlesStatuses[articleIndex].saving">
                                                                <b-button
                                                                    class="btn btn-primary rounded-right"
                                                                    disabled
                                                                >
                                                                    {{$t("Salvataggio")}}
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </div>
                                                </div>
                                            </td>
                                            <!--<td class="costo align-middle px-1" data-title="Costo di laboratorio">
                                                <span class="font-weight-bold">
                                                    {{ parseFloat(article.prezzoPortale) | toCurrency }}
                                                </span>
                                            </td>-->
                                            <td
                                                class="prezzo align-middle px-1"
                                                data-title="Prezzo"
                                            >
                                                <b-input-group
                                                    append="€"
                                                    class="mb-0 w-75"
                                                >
                                                    <b-input
                                                        type="number"
                                                        class="text-right font-weight-bold"
                                                        min="0.00"
                                                        step="0.50"
                                                        v-model="article.prezzo"
                                                        data-price="article.prezzo"
                                                        @blur="onArticlePriceChange($event, articleIndex)"
                                                    ></b-input>
                                                </b-input-group>
                                            </td>
                                            <!--<td class="guadagno align-middle px-1" data-title="Guadagno">
                                                <span
                                                    class="font-weight-bold"
                                                    :class="{
                                                        'text-success':
                                                            article.prezzo >=
                                                            article.prezzoPortale,
                                                        'text-danger':
                                                            article.prezzo <
                                                            article.prezzoPortale
                                                    }"
                                                >
                                                    {{
                                                        (article.prezzo -
                                                            article.prezzoPortale)
                                                            | toCurrency
                                                    }}
                                                </span>
                                            </td>-->
                                            <td class="rimuovi align-middle px-1 text-center">
                                                <a
                                                    class="btn"
                                                    v-show="activeCategory.removableArticles"
                                                    @click="saveArticles([], [],[article.codArticolo])"
                                                >
                                                    <font-awesome-icon :icon="['fas', 'trash']" />
                                                </a>
                                            </td>
                                        </tr>
                                    </draggable>
                                </table>

                                <div class="controlli row mt-3 d-flex justify-content-between align-items-center flex-wrap">
                                    <div class="d-flex justify-content-start align-items-center col-lg-7 mt-3 mt-lg-0">
                                        <button
                                            type="button"
                                            class="btn btn-light border"
                                            @click="showPricelistArticlesModal"
                                            v-show="activeCategory.articles && activeCategory.articles.length>0 && activeCategory.idGruppo !== 'spese'"
                                        >
                                            {{ $t("Aggiungi elemento") }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <backend-footer />

            <!-- popup nuova categoria -->
            <b-modal
                id="new-category-modal"
                title="Nuova categoria"
                @show="resetNewCategoryModal"
                @hidden="resetNewCategoryModal"
                @ok="createNewCategory"
            >
                <div class="form-row mt-3">
                    <div class="col-sm-6">
                        <label for="newCategoryName">{{ $t("Nome") }}</label>
                        <input
                            type="text"
                            class="form-control"
                            id="newCategoryName"
                            v-model="newCategory.name"
                        />
                    </div>
                </div>

                <template v-slot:modal-footer="{ ok, cancel }">
                    <b-button
                        class="btn btn-light border"
                        @click="cancel()"
                    >
                        {{ $t("Annulla") }}
                    </b-button>
                    <b-button
                        class="btn btn-primary btn-rikorda1"
                        @click="ok()"
                    >
                        {{ $t("Aggiungi") }}
                    </b-button>
                </template>
            </b-modal>

            <!-- popup rimozione categoria -->
            <b-modal
                id="delete-category-modal"
                title="Rimuovi categoria"
                cancel-title="Annulla"
                ok-title="Conferma"
                @ok="deleteCategory"
            >
                {{$t('Vuoi rimuovere la categoria ' + activeCategory.nome)}}?
                <div
                    v-show="Array.isArray(activeCategory.articles) && activeCategory.articles.length"
                    class="mt-2"
                >
                    {{$t('Attenzione: questa azione rimuoverà anche tutti gli articoli presenti nella categoria!')}}
                </div>
                <template #modal-footer="{ ok, cancel }">
                    <b-button
                        class="btn btn-light border"
                        @click="cancel()"
                    >
                        {{ $t("Annulla") }}
                    </b-button>
                    <b-button
                        class="btn btn-danger"
                        @click="ok()"
                    >
                        {{ $t("Elimina") }}
                    </b-button>
                </template>
            </b-modal>

            <pricelist-articles-modal
                ref="pricelistArticlesModal"
                v-show="isPricelistArticlesModalVisible"
                :pricelist-id="pricelistId"
                @close="hidePricelistArticlesModal"
            />

            <pricelist-assign-to-events-modal
                ref="pricelistAssignToEventsModal"
                :pricelist-id="pricelistId"
            />

            <!-- popup aggiunta articoli a listino free -->
            <b-modal
                id="pricelist-free-articles-modal"
                title="Aggiungi articolo"
                cancel-title="Annulla"
                ok-title="Aggiungi"
                size="lg"
                @show="resetFreeArticlesModal"
                @hidden="resetFreeArticlesModal"
                @ok="freePricelistHandleOk"
            >
                <form
                    ref="pricelist-free-articles-modal-form"
                    @submit.stop.prevent="freePricelistHandleSubmit"
                >
                    <div
                        class="form-row col-sm-12"
                        v-for="(each, i) in selectedCats"
                        :key="'cat-'+i"
                    >
                        <select
                            v-if="selectedCats[i]"
                            class="form-control rounded-pill rilievo-ombra-interna mt-1"
                            v-model="selectedCats[i]"
                            :disabled="selectedCats[i].id=='customizable'"
                            @change="onFreePricelistCategoryChange(i)"
                        >
                            <option
                                v-for="(category, j) in selectedCatItems[i]"
                                :key="'cat-'+i+'-opt-'+j"
                                :value="category"
                            >{{category.label + (category.label2 ? ' ('+category.label2+')' : '')}}</option>
                        </select>
                    </div>

                    <div
                        class="form-row col-sm-12"
                        v-for="(each, i) in selectedProds"
                        :key="'prod-'+i"
                    >
                        <select
                            v-if="selectedProds[i]"
                            class="form-control rounded-pill rilievo-ombra-interna mt-1"
                            v-model="selectedProds[i]"
                            @change="onFreePricelistProductChange(i)"
                        >
                            <option
                                v-for="(product, j) in selectedProdItems[i]"
                                :key="'prod-'+i+'-opt-'+j"
                                :value="product"
                            >{{product.label + (product.label2 ? ' ('+product.label2+')' : '')}}</option>
                        </select>
                    </div>

                    <div class="form-row col-sm-8 mt-1 float-left">
                        <label
                            for="product-description"
                            class="mb-0"
                        >{{ $t("Descrizione") }}:</label>
                        <input
                            id="product-description"
                            name="product-description"
                            type="text"
                            class="form-control rounded-pill rilievo-ombra-interna"
                            v-model="selectedProduct.description"
                            :style="{borderColor: (selectedProductDescriptionError ? 'red': '')}"
                            @blur="checkFreePricelistFormValidity"
                        />
                        <small
                            v-if="selectedProductDescriptionError"
                            class="text-danger"
                        >{{ $t("Descrizione non valida") }}</small>
                    </div>

                    <div class="form-row col-sm-4 mt-1 float-left">
                        <label
                            for="product-price"
                            class="mb-0"
                        >{{ $t("Prezzo") }}:</label>
                        <b-input-group
                            append="€"
                            class="mb-0"
                        >
                            <b-input
                                id="product-price"
                                name="product-price"
                                type="number"
                                class="text-right font-weight-bold"
                                min="0.00"
                                step="0.50"
                                v-model="selectedProduct.price"
                                data-price="selectedProduct.price"
                                :style="{borderColor: (selectedProductPriceError ? 'red': '')}"
                                @blur="checkFreePricelistFormValidity"
                            ></b-input>
                        </b-input-group>
                        <small
                            v-if="selectedProductPriceError"
                            class="text-danger"
                        >{{ $t("Prezzo non valido") }}</small>
                    </div>

                    <div class="clearfix"></div>
                </form>

                <template
                    v-slot:modal-footer="{ ok, cancel }"
                    class="pt-0"
                >
                    <small
                        class="form-row col-sm-12 text-danger"
                        v-show="selectedProductAlreadyChoosen"
                    >
                        {{ $t("L'articolo è già presente nel listino") }}
                    </small>
                    <small
                        class="form-row col-sm-12 text-success"
                        v-show="selectedProductAdded"
                    >
                        {{ $t("L'articolo è stato aggiunto") }}
                    </small>
                    <b-button
                        class="btn btn-light border float-left"
                        @click="cancel()"
                    >
                        {{ $t("Chiudi") }}
                    </b-button>
                    <b-button
                        class="btn btn-primary btn-rikorda1"
                        @click="ok()"
                    >
                        {{ $t("Aggiungi") }}
                    </b-button>
                </template>
            </b-modal>

            <!-- popup editing anteprima prodotti personalizzabili del listino free -->
            <b-modal
                id="pricelist-free-articles-edit-preview-modal"
                title="Personalizzazione anteprima articolo"
                cancel-title="Chiudi"
                ok-title="Salva"
                size="lg"
                @ok.prevent="onUploadPreview"
                :ok-disabled="previewUploading"
                :cancel-disabled="previewUploading"
            >
                <template slot="modal-ok">
                    <b-button
                        small
                        variant="primary"
                        class="p-0"
                    >
                        <b-spinner
                            small
                            style="vertical-align: middle;"
                            v-show="previewUploading"
                        ></b-spinner>
                        Salva
                    </b-button>
                </template>

                <div class="text-center">
                    <img
                        ref="previewImage"
                        style="width: 50%; height: 50%;"
                        :src="articlePreviewDataSrc(editArticlePreview)"
                    />
                </div>
                <div class="text-center">
                    <small>{{ $t("Carica un'anteprima personalizzata, scegliendo il file e poi cliccando su Salva") }}</small>
                    <b-form-file
                        :disabled="previewUploading"
                        ref="previewFile"
                        type="file"
                        accept="image/png,image/jpeg"
                        name="previewFile"
                        id="previewFile"
                        class="col order-3 order-md-2 mt-2 mt-md-0"
                        style="text-align-last: center; margin: auto;"
                        @change.native="previewChanged()"
                    />
                </div>
                <div
                    class="text-center"
                    v-show="isCustomPreview()"
                >
                    <small>{{ $t("oppure ripristina l'anteprima predefinita") }}</small>
                    <br />
                    <b-button @click="onResetPreview()">{{$t("Reimposta")}}</b-button>
                </div>
            </b-modal>
        </div>
    </div>
</template>
<script>
import draggable from "vuedraggable";
import BackendFooter from "../../../components/backend/Footer";
import PricelistArticlesModal from "../../../components/backend/PricelistArticlesModal";
import PricelistAssignToEventsModal from "../../../components/backend/PricelistAssignToEventsModal";

export const ProductTypes = Object.freeze({
    PRINT: "PRINT",
    PROJECT: "PROJECT"
});

export default {
    name: "BackendPricelist",

    components: {
        draggable,
        BackendFooter,
        PricelistArticlesModal,
        PricelistAssignToEventsModal
    },

    data() {
        return {
            pricelistId: "",
            pricelist: {},
            categories: [],
            activeCategory: {},
            savingState: "",

            newCategory: {
                name: ""
            },

            editingPricelistName: false,
            savingPricelistName: false,
            isPricelistArticlesModalVisible: false,

            freePricelistCategories: [],
            freePricelistProducts: {},

            selectedCats: [null, null, null, null, null, null, null, null],
            selectedCatItems: [null, null, null, null, null, null, null, null],

            selectedProds: [null, null, null],
            selectedProdItems: [null, null, null],

            selectedProduct: {
                code: null,
                description: "",
                price: 0,
                productType: ProductTypes.PRINT,
                productId: "",
                themeUrl: ""
            },
            selectedProductDescriptionError: false,
            selectedProductPriceError: false,
            selectedProductAdded: false,
            selectedProductAlreadyChoosen: false,
            selectedProductTypeIsProject: false,

            articlesStatuses: [],
            editArticlePreview: null,
            previewUploading: false
        };
    },

    mounted() {
        this.pricelistId = this.$route.params.pricelistId;
        this.loadPriceList();
    },

    methods: {
        loadPriceList() {
            return this.$api
                .backendGetPricelist(this.pricelistId)
                .then((response) => {
                    console.debug("BACKEND_GET_PRICE_LIST", response);
                    if (
                        response.pricelist &&
                        Object.prototype.hasOwnProperty.call(
                            response.pricelist,
                            "idListino"
                        )
                    ) {
                        this.pricelist = response.pricelist;
                        this.$api
                            .backendGetProductCategorizations(
                                this.pricelist.rapporto
                            )
                            .then((response) => {
                                console.log(
                                    "BACKEND_GET_PRODUCT_CATEGORIZATIONS",
                                    response
                                );
                                var result = response.result;
                                this.freePricelistCategories = result.categories
                                    ? result.categories
                                    : [];
                                this.freePricelistProducts = result.products
                                    ? result.products
                                    : {};
                            })
                            .catch((error) => {
                                console.error(
                                    "BACKEND_GET_PRODUCT_CATEGORIZATIONS",
                                    error
                                );
                            });

                        if (response.categories) {
                            this.categories = response.categories;
                            if (this.categories.length > 0) {
                                this.changeActiveCategory(this.categories[0]);
                            }

                            if (!this.hasDefaultCategory()) {
                                this.$bvModal.show("new-category-modal");
                            }
                        }
                    } else {
                        this.goToPricelists();
                    }
                })
                .catch((error) => {
                    console.error("BACKEND_GET_PRICE_LIST", error);
                });
        },

        changeActiveCategory(category) {
            this.activeCategory = category;
            if (this.activeCategory.idGruppo === "spese") {
                this.activeCategory.sortableArticles = false;
                this.activeCategory.removableArticles = false;
            } else {
                this.articlesStatuses = [];
                this.activeCategory.articles.forEach((article) => {
                    this.articlesStatuses.push({
                        editing: false,
                        saving: false,
                        nomeOld: article.nome
                    });
                });
                this.activeCategory.sortableArticles = true;
                this.activeCategory.removableArticles = true;
            }
        },

        setPricelistName() {
            var newName = this.$refs.pricelistNameInput.vModelValue
                .trim()
                .substring(0, 45);
            if (newName.length > 0 && this.pricelist.nome !== newName) {
                this.savingPricelistName = true;
                var pricelist = JSON.parse(JSON.stringify(this.pricelist));
                pricelist.name = newName;
                this.$api
                    .backendSavePricelist(pricelist)
                    .then((response) => {
                        this.pricelist.nome = newName;
                        this.savingPricelistName = false;
                        this.editingPricelistName = false;
                    })
                    .catch(() => {
                        this.savingPricelistName = false;
                    });
            } else {
                this.editingPricelistName = false;
            }
        },

        resetNewCategoryModal() {
            this.newCategory.name = !this.hasDefaultCategory() ? "Stampe" : "";
        },

        createNewCategory() {
            if (this.newCategory.name.length > 0) {
                this.$api
                    .backendCreatePricelistCategory(
                        this.pricelistId,
                        this.newCategory
                    )
                    .then((response) => {
                        if (response.categories) {
                            this.categories = response.categories;
                            if (this.categories.length > 0) {
                                this.changeActiveCategory(
                                    this.categories[this.categories.length - 2]
                                );
                            }
                        }
                    });
            }
        },

        deleteCategory() {
            this.$api
                .backendDeletePricelistCategory(
                    this.activeCategory.fkListino,
                    this.activeCategory.idGruppo
                )
                .then((response) => {
                    if (response.categories) {
                        this.categories = response.categories;
                        if (this.categories.length > 0) {
                            this.changeActiveCategory(
                                //this.categories[this.categories.length - 2]
                                this.categories[0]
                            );
                        }
                    }
                })
                .catch((error) => {
                    console.error("BACKEND_DELETE_PRICELIST_CATEGORY", error);
                });
        },

        sortCategories(changes) {
            var i,
                categories = [];
            for (i = 0; i < this.categories.length; i++) {
                categories.push(this.categories[i].idGruppo);
            }
            return this.$api
                .backendSortPricelistCategories(this.pricelistId, categories)
                .then(() => {});
        },

        checkCategorySort(e) {
            const { index, futureIndex } = e.draggedContext;
            const relatedContext = e.relatedContext;
            let speseIndex = -1;
            this.categories.forEach((item, index) => {
                if (item.idGruppo === "spese") {
                    speseIndex = index;
                }
            });
            return relatedContext.index < speseIndex;
        },

        showPricelistArticlesModal() {
            if (this.isFreePricelist) {
                this.$bvModal.show("pricelist-free-articles-modal");
            } else {
                this.$refs.pricelistArticlesModal.categoryId =
                    this.activeCategory.idGruppo;
                return this.$refs.pricelistArticlesModal
                    .loadArticles()
                    .then((response) => {
                        this.isPricelistArticlesModalVisible = response;
                    });
            }
        },

        hidePricelistArticlesModal(params) {
            if (params.updatePricelist) {
                return this.$api
                    .backendGetPricelist(this.pricelistId)
                    .then((response) => {
                        if (response.categories) {
                            this.categories = response.categories;

                            for (var i = 0; i < this.categories.length; i++) {
                                if (
                                    this.categories[i].idGruppo ===
                                    this.activeCategory.idGruppo
                                ) {
                                    this.changeActiveCategory(
                                        this.categories[i]
                                    );
                                    break;
                                }
                            }
                        }
                        this.isPricelistArticlesModalVisible = false;
                    });
            } else {
                this.isPricelistArticlesModalVisible = false;
            }
        },

        sortArticles(changes) {
            var i,
                articles = [];
            for (i = 0; i < this.activeCategory.articles.length; i++) {
                articles.push(this.activeCategory.articles[i].codArticolo);
            }
            return this.$api
                .backendSortPricelistCategoryArticles(
                    this.pricelistId,
                    this.activeCategory.idGruppo,
                    articles
                )
                .then(() => {});
        },

        saveArticles(articlesToAdd, articlesToUpdate, articlesToRemove) {
            articlesToAdd = articlesToAdd || [];
            articlesToUpdate = articlesToUpdate || [];
            articlesToRemove = articlesToRemove || [];
            var articles = {
                add: articlesToAdd,
                update: articlesToUpdate,
                remove: articlesToRemove
            };
            return this.$api
                .backendSavePricelistCategoryArticles(
                    this.pricelistId,
                    this.activeCategory.idGruppo,
                    articles
                )
                .then((response) => {
                    if (
                        response.pricelist &&
                        Object.prototype.hasOwnProperty.call(
                            response.pricelist,
                            "idListino"
                        )
                    ) {
                        this.pricelist = response.pricelist;

                        if (response.categories) {
                            this.categories = response.categories;

                            for (var i = 0; i < this.categories.length; i++) {
                                if (
                                    this.categories[i].idGruppo ===
                                    this.activeCategory.idGruppo
                                ) {
                                    this.changeActiveCategory(
                                        this.categories[i]
                                    );
                                    break;
                                }
                            }
                        }
                    } else {
                        this.goToPricelists();
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        },

        onArticlePriceChange($event, articleIndex) {
            var article = this.activeCategory.articles[articleIndex];
            if (article) {
                var newPrice = 0;
                try {
                    newPrice = parseFloat(article.prezzo).toFixed(2);
                } catch (e) {
                    newPrice = 0;
                }

                if (
                    newPrice > 0 ||
                    (article.fkGruppo === "spese" && newPrice >= 0)
                ) {
                    newPrice = newPrice.replace(",", ".");
                    this.activeCategory.articles[articleIndex].prezzo =
                        newPrice;

                    if (this.activeCategory.idGruppo === "spese") {
                        var transferts = {};
                        transferts[
                            this.activeCategory.articles[
                                articleIndex
                            ].codArticolo
                        ] = newPrice;
                        this.$api.backendSavePricelistTransferts(
                            this.pricelistId,
                            transferts
                        );
                    } else {
                        this.saveArticles(
                            [],
                            [this.activeCategory.articles[articleIndex]],
                            []
                        );
                    }
                }
            }
        },

        onArticleNameChange($event, articleIndex) {
            var article = this.activeCategory.articles[articleIndex];
            if (article) {
                var articleStatus = this.articlesStatuses[articleIndex];
                article.nome = article.nome.trim().substring(0, 45);
                if (
                    article.nome.length > 0 &&
                    articleStatus.nomeOld != article.nome
                ) {
                    articleStatus.saving = true;
                    articleStatus.nomeOld = article.nome;

                    this.saveArticles(
                        [],
                        [this.activeCategory.articles[articleIndex]],
                        []
                    ).then(() => {
                        articleStatus.saving = false;
                        articleStatus.editing = false;
                    });
                } else {
                    articleStatus.saving = false;
                    articleStatus.editing = false;
                }
            }
        },

        showPricelistAssignToEventsModal() {
            this.$bvModal.show("pricelist-assign-to-events-modal");
            return this.$refs.pricelistAssignToEventsModal.load();
        },

        goToPricelists() {
            this.$router.push({ name: "backend-sales-pricelists" });
        },

        resetFreeArticlesModal() {
            this.selectedCatItems = [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null
            ];
            this.selectedCats = [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null
            ];
            this.selectedProds = [null, null, null];
            this.selectedProdItems = [null, null, null];

            this.selectedProduct = {
                code: null,
                description: "",
                price: 0,
                productType: ProductTypes.PRINT,
                productId: "",
                themeUrl: ""
            };
            this.selectedProductTypeIsProject =
                this.selectedProduct.productType == ProductTypes.PROJECT;

            var currentFreePricelistCategories;
            if (this.activeCategory.tipoGruppo == "CUSTOMIZABLE") {
                currentFreePricelistCategories =
                    this.freePricelistCategories.filter((category) => {
                        return category.id == "customizable";
                    });
            } else {
                currentFreePricelistCategories = this.freePricelistCategories;
            }

            var filteredCats = currentFreePricelistCategories.filter(
                (category) => {
                    if (
                        !Object.prototype.hasOwnProperty.call(category, "items")
                    ) {
                        return (
                            Object.prototype.hasOwnProperty.call(
                                this.freePricelistProducts,
                                category.id
                            ) &&
                            this.freePricelistProducts[category.id] &&
                            this.freePricelistProducts[category.id].length > 0
                        );
                    } else {
                        return category.items && category.items.length > 0;
                    }
                }
            );

            this.selectedCatItems[0] =
                filteredCats.length > 0 ? filteredCats : null;

            var defaultCat = filteredCats.filter((cat) => {
                return cat.default;
            });

            this.selectedCats[0] =
                defaultCat.length > 0
                    ? defaultCat[0]
                    : filteredCats.length > 0
                    ? filteredCats[0]
                    : null;

            this.onFreePricelistCategoryChange(0);
        },

        onFreePricelistCategoryChange(index) {
            this.selectedProductAdded = false;
            this.selectedProductAlreadyChoosen = false;
            this.selectedProductDescriptionError = false;
            this.selectedProductPriceError = false;
            this.selectedProductTypeIsProject = false;

            for (var i = index + 1; i < 8; i++) {
                this.selectedCats[i] = null;
                this.selectedCatItems[i] = null;
            }

            if (
                this.selectedCats[index] &&
                this.selectedCats[index].items &&
                this.selectedCats[index].items.length > 0
            ) {
                var filteredCats = this.selectedCats[index].items.filter(
                    (category) => {
                        if (
                            !Object.prototype.hasOwnProperty.call(
                                category,
                                "items"
                            )
                        ) {
                            return (
                                Object.prototype.hasOwnProperty.call(
                                    this.freePricelistProducts,
                                    category.id
                                ) &&
                                this.freePricelistProducts[category.id].length >
                                    0
                            );
                        } else {
                            return category.items && category.items.length > 0;
                        }
                    }
                );
                if (filteredCats.length > 0) {
                    this.selectedCatItems[index + 1] = filteredCats;

                    var defaultCat = filteredCats.filter((cat) => {
                        return cat.default;
                    });

                    this.selectedCats[index + 1] =
                        defaultCat.length > 0 ? defaultCat[0] : filteredCats[0];

                    this.onFreePricelistCategoryChange(index + 1);
                }
            } else if (
                this.selectedCats[index] &&
                !Object.prototype.hasOwnProperty.call(
                    this.selectedCats[index],
                    "items"
                )
            ) {
                this.selectedProdItems[0] =
                    this.freePricelistProducts[this.selectedCats[index].id];

                var defaultProds = this.selectedProdItems[0].filter(
                    (product) =>
                        Object.prototype.hasOwnProperty.call(
                            product,
                            "default"
                        ) && product.default
                );

                this.selectedProds[0] =
                    defaultProds.length > 0
                        ? defaultProds[0]
                        : this.selectedProdItems[0][0];

                if (this.selectedProds[0]) {
                    this.onFreePricelistProductChange(0);
                }
            }
        },

        onFreePricelistProductChange(index) {
            this.selectedProductAdded = false;
            this.selectedProductAlreadyChoosen = false;
            this.selectedProductDescriptionError = false;
            this.selectedProductPriceError = false;
            this.selectedProductTypeIsProject = false;

            for (var i = index + 1; i < 3; i++) {
                this.selectedProds[i] = null;
                this.selectedProdItems[i] = null;
            }

            if (
                this.selectedProds[index] &&
                this.selectedProds[index].items &&
                this.selectedProds[index].items.length > 0
            ) {
                this.selectedProdItems[index + 1] =
                    this.selectedProds[index].items;

                var defaultProds = this.selectedProds[index].items.filter(
                    (product) =>
                        Object.prototype.hasOwnProperty.call(
                            product,
                            "default"
                        ) && product.default
                );

                this.selectedProds[index + 1] =
                    defaultProds.length > 0
                        ? defaultProds[0]
                        : this.selectedProds[index].items[0];

                this.onFreePricelistProductChange(index + 1);
            } else {
                // visualizza descrizione e prezzo
                var description = [this.selectedProds[0].label];
                if (this.selectedProds[0].label2) {
                    description.push("(" + this.selectedProds[0].label2 + ")");
                }
                if (this.selectedProds[1] && this.selectedProds[1].label) {
                    description.push(this.selectedProds[1].label);
                }
                if (this.selectedCats[0] && this.selectedCats[0].label) {
                    switch (this.selectedCats[0].label) {
                        case "Preferiti": // non le aggiunge come label al prodotto
                        case "Amatoriale":
                        case "Articoli Personalizzabili":
                            break;
                        default:
                            description.push(this.selectedCats[0].label);
                            break;
                    }
                }

                this.selectedProduct = {
                    code: this.selectedProds[index].code,
                    description: description.join(" "),
                    price: 0,
                    productType:
                        this.selectedProds[0].tipo || ProductTypes.PRINT,
                    productId: this.selectedProds[index].productId || "",
                    themeUrl: this.selectedProds[index].themeUrl || ""
                };
                this.selectedProductTypeIsProject =
                    this.selectedProduct.productType == ProductTypes.PROJECT;
            }
        },

        checkFreePricelistFormValidity() {
            // articolo già in listino
            this.selectedProductAlreadyChoosen = this.categories.some(
                (category) => {
                    if (category.articles) {
                        if (
                            category.articles.some((article) => {
                                return (
                                    article.codArticolo ===
                                        this.selectedProduct.code &&
                                    article.productId ===
                                        this.selectedProduct.productId &&
                                    article.themeUrl ===
                                        this.selectedProduct.themeUrl
                                );
                            })
                        ) {
                            return true;
                        }
                    }
                }
            );

            // descrizione non valida
            this.selectedProductDescriptionError =
                !this.selectedProductAlreadyChoosen &&
                this.selectedProduct.description.length == 0;
            // prezzo non valido
            this.selectedProductPriceError =
                !this.selectedProductAlreadyChoosen &&
                this.selectedProduct.price <= 0;

            if (
                this.selectedProductAlreadyChoosen ||
                this.selectedProductDescriptionError ||
                this.selectedProductPriceError
            ) {
                // form non valida
                return false;
            }

            // form valida
            return true;
        },

        freePricelistHandleOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault();
            // Trigger submit handler
            if (this.freePricelistHandleSubmit()) {
                // aggiunta articolo al listino free
                var articlesToAdd = [
                    {
                        codArticolo: this.selectedProduct.code,
                        nome: this.selectedProduct.description,
                        prezzo: this.selectedProduct.price,
                        tipo: this.selectedProduct.productType,
                        productId: this.selectedProduct.productId,
                        themeUrl: this.selectedProduct.themeUrl
                    }
                ];
                this.saveArticles(articlesToAdd, [], []);
            }
        },

        freePricelistHandleSubmit() {
            // reset flags before validation
            this.selectedProductAlreadyChoosen = false;
            this.selectedProductAdded = false;

            // Exit when the form isn't valid
            if (!this.checkFreePricelistFormValidity()) {
                return false;
            }

            // prodotto aggiunto al listino
            this.selectedProductAdded = true;

            // Push the name to submitted names
            //this.submittedNames.push(this.name)
            // Hide the modal manually
            /*this.$nextTick(() => {
                this.$bvModal.hide("pricelist-free-articles-modal");
            });*/

            return true;
        },

        isProjectProduct(article) {
            return article.tipo == ProductTypes.PROJECT;
        },

        onEditPreview(article) {
            this.editArticlePreview = article;
            this.$bvModal.show("pricelist-free-articles-edit-preview-modal");
        },

        isCustomPreview() {
            return (
                this.editArticlePreview &&
                this.editArticlePreview.anteprima &&
                !this.editArticlePreview.anteprima.startsWith(
                    "/media/catalog/themes"
                )
            );
        },

        previewChanged() {
            const file = this.$refs.previewFile.files[0];
            if (file) {
                this.$refs.previewImage.src = window.URL.createObjectURL(file);
            }
        },

        onResetPreview() {
            this.previewUploading = true;
            this.$api
                .backendSaveCustomizableProductPreview({
                    fkGruppo: this.editArticlePreview.fkGruppo,
                    codArticolo: this.editArticlePreview.codArticolo,
                    productId: this.editArticlePreview.productId,
                    themeUrl: this.editArticlePreview.themeUrl,
                    previewImage: null
                })
                .then((response) => {
                    console.log(
                        "BACKEND_SAVE_CUSTOMIZABLE_PRODUCT_PREVIEW",
                        response
                    );
                    // update anteprima su articolo in elenco
                    if (response.preview) {
                        this.editArticlePreview.anteprima = response.preview;
                    }
                })
                .catch((error) => {
                    console.error(
                        "BACKEND_SAVE_CUSTOMIZABLE_PRODUCT_PREVIEW",
                        error
                    );
                })
                .finally(() => {
                    this.previewUploading = false;
                });
        },

        onUploadPreview() {
            this.previewUploading = true;
            const file = this.$refs.previewFile.files[0]; // <input type='file' />
            if (file) {
                this.$utilsService
                    .getPreviewImageFromInput(file)
                    .then((previewImage) => {
                        //this.editArticlePreview.anteprima = previewImage;
                        this.$api
                            .backendSaveCustomizableProductPreview({
                                fkGruppo: this.editArticlePreview.fkGruppo,
                                codArticolo:
                                    this.editArticlePreview.codArticolo,
                                productId: this.editArticlePreview.productId,
                                themeUrl: this.editArticlePreview.themeUrl,
                                previewImage: previewImage
                            })
                            .then((response) => {
                                console.log(
                                    "BACKEND_SAVE_CUSTOMIZABLE_PRODUCT_PREVIEW",
                                    response
                                );
                                // update anteprima su articolo in elenco
                                if (response.preview) {
                                    this.editArticlePreview.anteprima =
                                        response.preview;
                                }
                            })
                            .catch((error) => {
                                console.error(
                                    "BACKEND_SAVE_CUSTOMIZABLE_PRODUCT_PREVIEW",
                                    error
                                );
                            })
                            .finally(() => {
                                this.previewUploading = false;
                                this.$bvModal.hide(
                                    "pricelist-free-articles-edit-preview-modal"
                                );
                            });
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }
        },

        articlePreviewDataSrc(article) {
            if (article && article.anteprima) {
                if (article.anteprima.startsWith("/media/catalog/themes")) {
                    let url = new URL(process.env.VUE_APP_API_BASE_URL);
                    let hostname =
                        location.hostname === "localhost"
                            ? url.origin
                            : location.origin;
                    return hostname + article.anteprima;
                } else {
                    return "data:image/jpeg;base64," + article.anteprima;
                }
            }
            // image placeholder
            return "data:image/png;base64,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";
        },

        hasDefaultCategory() {
            return (
                this.categories.filter((category) => {
                    return category.tipoGruppo != "CUSTOMIZABLE";
                }).length > 1
            );
        }
    },

    computed: {
        isFreePricelist() {
            return this.pricelist && this.pricelist.tipoListino === "FREE";
        }
    }
};
</script>

<style scoped>
</style>
